import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemMiddlewareName, FormItemMiddlewareType} from '../MID/FormChooseMid.jsx'
import Model from './ModelMidins.mjs'

export const FormItemMiddlewareInsName = props => (
    <FormItemBizProp
        Model={Model}
        prop="middlewareInsName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemIp = props => (
    <FormItemBizProp
        Model={Model}
        prop="ip"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseMidins(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemMiddlewareName />
            <FormItemMiddlewareType />
            <FormItemMiddlewareInsName />
            <FormItemIp />
        </FormChooseDesign>
    )
}
